import React, { useState, useEffect, useRef } from 'react';
import Drawer from '@material-ui/core/Drawer';
import Typography from "@material-ui/core/Typography";
import Select from '@material-ui/core/Select';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import InputAdornment from '@material-ui/core/InputAdornment';
import CardHistorico from './card/index';
import useStyles from './styles';
import { getAll } from '../../services/historico/HistoricoService';

const Historico = (props) => {

  const { open, onClose } = props;

  const classes = useStyles();
  const [historico, setHistorico] = useState([]);
  const isFirstRender = useRef(true);

  const [filtro, setFiltro] = useState({
    quantidadeDias: '',
    busca: '',
  })

  useEffect(() => {
    setHistorico(props.historico)
  }, [props.historico])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFiltro({ ...filtro, [name]: value })
  }

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    getAll(filtro).then((response) => {
      if (response && response.status === 200) {
        const { data } = response;
        setHistorico(data)
      }
    })
  }, [filtro]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  return (
    <>
      <div className={classes.bar}>
        <Drawer
          variant="persistent"
          open={open}
          onClose={onClose}
          anchor="right"
          classes={{
            paper: classes.paper,
          }}
        >
          <div style={{ padding: 20 }}>
            <Typography className={classes.titulo}>Histórico de gestão</Typography>
            <form>
              <InputLabel shrink id="filtroPeríodo">Filtrar por período</InputLabel>
              <Select
                onClick={handleClick}
                labelId="filtroPeríodo"
                name="quantidadeDias"
                fullWidth
                native
                displayEmpty
                variant="outlined"
                value={filtro.quantidadeDias}
                onChange={handleChange}
                style={{ marginBottom: 20 }}
                IconComponent={ExpandMoreIcon}
              >
                <option value={7}>7 dias</option>
                <option value={30}>30 dias</option>
                <option value={90}>3 meses</option>
                <option value={180}>6 meses</option>
                <option value={365}>12 meses</option>
                <option value={''}>Tudo</option>
              </Select>
              <div>
                <TextField
                  fullWidth
                  name="busca"
                  variant='outlined'
                  value={filtro.busca}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  placeholder="digite sua pesquisa"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ color: '#0B4FD9', cursor: 'pointer' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (filtro.busca ?
                      <InputAdornment onClick={() => setFiltro({ ...filtro, busca: '' })}
                        position="start">
                        <CloseIcon style={{ color: '#5e6784', cursor: 'pointer' }} />
                      </InputAdornment> : <></>
                    ),
                  }} />
              </div>
            </form>
          </div>
          <div>
            <Typography className={classes.subtitulo}>Aprovação e convites</Typography>
            {historico.map((hist, key) => (
              <CardHistorico dados={hist} key={key} />
            ))}
          </div>
        </Drawer>
      </div>
    </>
  );
}

export default Historico;
